import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { FloatingCartBar } from "./components/FloatingCartBar";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { Home } from "./pages/Home";
import { Products } from "./pages/Products";
import { Checkout } from "./pages/Checkout";
import { Login } from "./pages/Login";
import { Admin } from "./pages/Admin";

function App() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <AuthProvider>
      <CartProvider>
        <div className="App min-h-screen flex flex-col">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={
                <>
                  <Header onCartClick={() => setCartOpen(true)} />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/produtos" element={<Products />} />
                      <Route path="/checkout" element={<Checkout />} />
                    </Routes>
                  </main>
                  <Footer />
                  <CartDrawer open={cartOpen} onOpenChange={setCartOpen} />
                  <FloatingCartBar onCartClick={() => setCartOpen(true)} />
                  <WhatsAppFloat />
                </>
              } />
            </Routes>
          </BrowserRouter>
          
          <Toaster position="top-center" richColors />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
